// import RegisterAgreement from '../components/RegisterAgreement'
import RegisterForm from '../components/RegisterForm'

export default function RegisterView() {
  return (
    <div className='wrapper'>
      <div className='contents-wrapper'>
        <div className='flex h-full w-full flex-col items-center justify-center'>
          <div className='flex flex-col items-center gap-20'>
            <p className='text-title2-bold text-label-default'>회원가입</p>
            <div>
              <div className='mb-6 h-6 w-100 bg-background-secondary' />
              <p className='text-center text-body2-semibold text-primary-normal'>약관동의</p>
            </div>
          </div>
          <RegisterForm />
        </div>
      </div>
    </div>
  )
}
